import React, { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";

// Services

import { 
  clearConsultaListasInternas,
  clearConsultaListasInternacionales, 
  clearConsultaAlertaSafeWatch, 
  clearConsultarConyugeEnListas, 
  clearConsultarApoderadoEnListas, 
  clearInsertarClienteEnListaParaRevision 
} from "../../store/lists/lists.actions";
import { handleResetFormSteps, cleanUpClienteDataParcial, cleanUpClienteExistente} from '../../store/forms/forms.actions';
import { cleanUpLogInStore } from "../../store/auth/auth.actions";

// Components

import Button from "../../components/UI/Button/Button";

// Styles

import "./Styles.scss";

export default function UserInList() {
  const { state } = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    if (state?.userPartialData?.is_blocked) {
      dispatch(cleanUpLogInStore());
      dispatch(cleanUpClienteExistente());
      dispatch(clearConsultaListasInternas());
      dispatch(clearConsultaListasInternacionales());
      dispatch(clearConsultaAlertaSafeWatch());
      dispatch(clearConsultarConyugeEnListas());
      dispatch(clearConsultarApoderadoEnListas());
      dispatch(clearInsertarClienteEnListaParaRevision());
      dispatch(handleResetFormSteps());
      dispatch(cleanUpClienteDataParcial());

      localStorage.removeItem("clientEmail");
      localStorage.removeItem('clientPhone');
    } else {
      navigate(`/`);
    }
  }, []);

  return (
    <div className="page-wrapper">
      <div className="container">

        <div className="onboarding-page">
          <div className="onboarding-wrapper">
            <h1>Proceso pendiente de aprobación</h1>

            <p>
              Su solicitud se encuentra en revisión y/o pendiente por autorizar.
            </p>
          </div>

          <Button
            type="button"
            action={() => navigate('/')}
            label={"Continuar"}
          />

        </div>

      </div>
    </div>
  );
}
